angular.module('routes.globalreports.GlobalReportsController', [
  'stack'
])

/**
 * The GlobalReportsController manages view logic rendered to the
 * reports.html template for the /global-reports reports.
 *
 * @class GlobalReportsController
 * @constructor
 * @module routes.globalreports.GlobalReportsController
 */
.controller('GlobalReportsController', [
  '$scope',
  'PaginationService',
  'ReportsService',
  'ModelsService',
  'ApiService',
  'GLOBAL',
  '$timeout',
  '$window',
  '$location',
  '$state',
  function ($scope, PaginationService, ReportsService,
    ModelsService, ApiService, GLOBAL, $timeout, $window, $location, $state) {
    'use strict';

    // defined urls for remote servers
    var servers = {
      ci: {
        authoring: 'https://develop.dcs.unicon.net',
        staging: 'https://master.dcs.unicon.net',
        production: 'https://master.dcs.unicon.net'
      },
      prod: {
        authoring: 'https://dev-dcs.pearsoncmg.com',
        staging: 'https://staging-dcs.pearsoncmg.com',
        production: 'https://dcs.pearsoncmg.com'
      }
    };

    // which environment we're starting with
    var currentServer = 'authoring';
    // current token
    var loginToken = JSON.parse($window.localStorage.newman).token;

    // checking to see if we're on CI servers or not
    if (_.includes($location.host(), 'unicon') || _.includes($location.host(), 'localhost')) {
      $scope.servers = servers.prod;
    } else {
      $scope.servers = servers.prod;
    }

    // so we can do some math in the template
    $scope.Math = Math;

    // initial view setup
    $scope.view = {
      server: 1,
      tab: 1,
      screen: 'cases',
      loading: true,
      loadingdetails: true
    };

    // tokens for each of the server environments
    $scope.token = {
      authoring: null,
      staging: null,
      production: null
    };

    // watches for tab switch
    $scope.$watch('view.server', function (nv) {
      if (nv === 1) {
        currentServer = 'authoring';
        $scope.casesCSVlabel = 'authoring-case-metrics';
      } else if (nv === 2) {
        currentServer = 'staging';
        $scope.casesCSVlabel = 'staging-case-metrics';
      } else if (nv === 3) {
        currentServer = 'production';
        $scope.casesCSVlabel = 'production-case-metrics';
      }
      getRemoteToken(currentServer);
    });

    /**
     * opens report in new window, with the access token from the url if it exists
     *
     * @param {string} id - report id
     */
    $scope.showReport = function (id) {
      $window.open($state.href('routes.reports', { reportId: id }) + '#' + $location.hash());
    };

    /**
     * gets tokens for remote servers allowing to make api requests against them
     *
     * @param {string} server - the selected student id
     */
    function getRemoteToken(server) {
      ApiService.getRemoteToken($scope.servers[server], loginToken)
      .then(function successCallback(response) {
        $scope.token[server] = 'Bearer ' + response.data.token;
        initialize();
        return true;
      }).catch();
    }

    $scope.dateformat = function (dt) {
      return moment(dt).format('MM.DD.YYYY@HH:mm');
    };

    /**
     * switches to reports list, sets filter to student and case
     *
     * @param {string} studentId - the selected student id
     * @param {string} caseId - the selected case id
     */
    $scope.filterReportsStudentCase = function (studentId, caseId) {
      _.forEach($scope.reports.filters['content.user'], function (uf) {
        if (uf.id === studentId) {
          uf.on = true;
        } else {
          uf.on = false;
        }
      });

      _.forEach($scope.reports.filters['content.simulation'], function (cf) {
        if (cf.id === caseId) {
          cf.on = true;
        } else {
          cf.on = false;
        }
      });

      $scope.view.tab = 2;
      $timeout(function () {
        $scope.reports.filterPages();
      });
    };

    /**
     * back to case list function
     *
     */
    $scope.backToCaseList = function () {
      $scope.view.screen = 'cases';
    };

    /**
     * Loads up a single case
     *
     * @param {Object} reportedCase - the selected case to view
     */
    $scope.caseReport = function (reportedCase) {
      $scope.view.loading = true;
      ModelsService.get(
        'cases',
        GLOBAL.apiPath + '/cases/' + reportedCase.id,
        {
          server: $scope.servers[currentServer],
          token: $scope.token[currentServer]
        },
        500000
      )
      .then(function (response) {
        $scope.currentCase = response;
        $scope.view.screen = 'case';
        $scope.view.loading = false;
        ReportsService.getCaseQuestions($scope.currentCase, reportedCase.reports, {
          server: $scope.servers[currentServer],
          token: $scope.token[currentServer]
        })
        .then(function () {
          $scope.view.loadingdetails = false;
          return true;
        }).catch();
        return true;
      })
      .catch();
    };

    /**
     * Initializes reports model in conjunction with pagination
     *
     */
    function initReports() {
      ModelsService.empty('reports');
      ModelsService.initialize(
          'reports',
          GLOBAL.apiPath + '/reports?limit=2000',
          500000,
          $scope.servers[currentServer],
          $scope.token[currentServer]
        )
        .then(function () {
          PaginationService.updateFullSet('reports', ['contextId', 'content.simulation', 'content.user']);
          $scope.reportedCases = ReportsService.getCases();

          $timeout(function () {
            $scope.reports.filterPages();
          });
          $scope.view.loading = false;

          return true;
        }).catch(function () {
          return false;
        });
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      $scope.view.tab = 1;
      $scope.view.screen = 'cases';
      $scope.view.loading = true;
      $scope.view.loadingdetails = true;

      $scope.reports = undefined;
      PaginationService.destroy('reports');

      if ($scope.reports === undefined) {
        PaginationService.paginate(
          'reports',
          GLOBAL.apiPath + '/reports',
          {
            limit: 10,
            perpage: 50,
            server: $scope.servers[currentServer],
            token: $scope.token[currentServer]
          })
        .then(function () {
          $scope.reports = PaginationService.get('reports');
          initReports();
          return true;
        }).catch();
      } else if (ReportsService.get().length && !$scope.reports.needsReload) {
        $scope.reports.needsReload = false;
        $scope.reports = PaginationService.get('reports');
        $scope.reportedCases = ReportsService.getCases();
        $scope.view.loading = false;
      } else {
        initReports();
      }
    }
  }
]);
